import { type JSX, type ReactNode } from 'react';

import { cn } from '@/lib/utils';

// SectionLabel — small uppercase caption with a trailing rule and an optional
// right-aligned aside (used for the campaign count), matching the mockup.
export function SectionLabel({
  children,
  aside,
  className,
}: {
  children: ReactNode;
  aside?: ReactNode;
  className?: string;
}): JSX.Element {
  return (
    <div className={cn('flex items-center gap-3 mb-2.5', className)}>
      <span className="text-[11px] font-semibold uppercase tracking-[0.13em] text-text-4">{children}</span>
      <span className="h-px flex-1 bg-line" aria-hidden />
      {aside != null && <span className="text-[11.5px] text-text-4 tabular-nums">{aside}</span>}
    </div>
  );
}
